// extracted by mini-css-extract-plugin
module.exports = {"rail":"BodyTypeRail_rail__e4eQ3","icon":"BodyTypeRail_icon__J4CdO"};